import { apiDelete, apiGet, apiPut } from './api-service';

const path = 'billing';

export interface UsageQueryParams {
    dateFrom?: string;
    dateTo?: string;
    groupByDate?: string;
    groupByDimension?: string;
    clientId?: string;
    usageType?: string;
}

export async function getUsage(params: UsageQueryParams) {
    const queryParams: Record<string, string> = {};
    if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
    if (params.dateTo) queryParams.dateTo = params.dateTo;
    if (params.groupByDate) queryParams.groupByDate = params.groupByDate;
    if (params.groupByDimension) queryParams.groupByDimension = params.groupByDimension;
    if (params.clientId) queryParams.clientId = params.clientId;
    if (params.usageType) queryParams.usageType = params.usageType;

    const response = await apiGet('core', `${path}/usage`, { queryParams });
    return response;
}
export interface PricingUpdateParams {
    id: string;
    cost_client_per_unit: number;
}

export async function updatePricing(params: PricingUpdateParams) {
    const response = await apiPut('core', `${path}/pricing/${params.id}`, params);
    return response;
}

export async function deletePricing(id: string) {
    const response = await apiDelete('core', `${path}/pricing/${id}`);
    return response;
}
